import React from "react";

interface SequentialRevealListProps {
  children: React.ReactNode;
  className?: string;
}

export function SequentialRevealList({
  children,
  className,
}: SequentialRevealListProps) {
  const nonNullChildren = React.Children.toArray(children).flat();

  return (
    <div className={className}>
      {React.Children.map(nonNullChildren, (child, index) => {
        return (
          <div
            key={index}
            className="opacity-0 animate-[fade-in-up_0.3s_ease-in_forwards] self-stretch"
            style={{
              animationDelay: `${index * 150}ms`,
            }}
          >
            {child}
          </div>
        );
      })}
    </div>
  );
}
